export function getPageTitle(title: string | undefined, globalTitle: string): string {
  if (!title) return globalTitle
  if (title.includes(globalTitle)) return title
  return [title, globalTitle].join(' · ')
}
